import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { adminChangesPassword, fetchAdminProfileDetails, updateAdminProfileDetails,  } from "../../../service/api";

export const getAdminProfile = createAsyncThunk(
    "profile/admin",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAdminProfileDetails(params)
            console.log("profile", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const editAdminProfile = createAsyncThunk(
    "profile/editAdmin",
    async (params, { rejectWithValue }) => {
        try {
            const response = await updateAdminProfileDetails(params)
            console.log("profile edit", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editAdminPasswordChange = createAsyncThunk(
    "profile/edit",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await adminChangesPassword(formData)
            if (response.status === 201) {
                console.log("edit change password", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

const profileSlice = createSlice({
    name: "adminProfile",
    initialState: {
        adminProfileDetails: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET ADMIN INFO
            .addCase(getAdminProfile.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAdminProfile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.adminProfileDetails = action.payload.data;

            })
            .addCase(getAdminProfile.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //PUT ADMIN
            .addCase(editAdminProfile.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editAdminProfile.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editAdminProfile.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //PUT
            .addCase(editAdminPasswordChange.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editAdminPasswordChange.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editAdminPasswordChange.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })



    }
})
export default profileSlice.reducer;